import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const siteHumanReadable = get(siteConf, '[og:site_name]');
  const author = get(state, 'author.data') || {};
  const authorName = get(author, 'name');
  const authorSlug = get(author, 'slug');
  const description = authorName
    ? `Articles and posts written and edited by ${authorName}`
    : `Author stories on ${siteHumanReadable}`;
  const title = authorName ? `${authorName}` : `${siteHumanReadable}`;

  const data = baseSeoUtil({
    site,
    siteConf,
    title,
    url: `https://www.${site}.com/user/${authorSlug}`,
    description,
    articleSection: authorName
  });

  return data;
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/author_seo_util.js